module.exports = __webpack_public_path__ + "img/profile-woman-11-min.8902a700.jpg";